import React, { Component } from 'react'
import { Switch, Route, withRouter, Link } from "react-router-dom";
import './AppAuth.css';
// import { theme } from './Theme';
import { Button, Icon } from '@material-ui/core';
import Side from './views/Side/Side'
import Preguia from './views/Recolecciones/preguia/Preguia';
import Catalogos from './views/Catalogos/Catalogos';
import Catalogo from './views/Catalogos/Catalogo';
import SearchNavigator from './views/searchNavigator/SearchNavigator';
import ConfiguracionSistema from './views/ConfiguracionSistema/ConfiguracionSistema';
import { ListaPreciosForm, ListaDePreciosIndex } from './views/Listaprecios';
import Http from './Http';
import Recolecciones from './views/Recolecciones/Recolecciones';
import Autorizar from './views/Recolecciones/preguia/Autorizar';
import Preguias from './views/Recolecciones/preguia/Preguias';
import Guias from './views/Documentacion/Guias';
import Rol from './views/RolesUsuario/Rol';
import RolAccess from './views/RolesUsuario/RolAccess';
import RolesUsuario from './views/RolesUsuario/Roles';
import FacturasEnviadas from './views/Ventas/facturacion/GuiasEnviadas';
import PendientesPorRecibir from './views/Ventas/facturacion/PendientesPorRecibir';
import RecibidasPorFacturacion from './views/Ventas/facturacion/RecepcionDeGuias';
import {
  Cotizaciones, Cotizacion, Corte, Ventas, Facturar, Facturas,
  FacturarCredito, FacturarCreditoV2, FacturasCredito, ControlPagos, Depositos, Deposito,
  AppBusqueda, AppDepositos, AppDeposito, PendientesFacturar, ConsecutivoFacturas,
  CalcularKM, FacturarUline, CorteRedocumentacion, GuiasRedocumentasRep, VentasConcepto,
  Completos, GuiasFactsPagos, RecibidasFact, VentasCliente, VentasEAD, RelacionFacturas,
  DiferenciaPagosRealizados, ReportePagoContado, PagosPendientesTimbrar, DiferenciaDePagos,
  DescargarArchivos, PolizaContable, MultipleCancelaciones, CancelacionesIndex, RelacionRutas,
  Refacturaciones, Refacturar,
} from './views/Ventas';
import { AuthContext } from "./context/authContext";
import NotasCredito from './views/Cobranza/NotasCredito/NotasCredito';
import NotaCredito from './views/Cobranza/NotasCredito/NotaCredito';
import ContraRecibos from './views/Cobranza/ContraRecibos/ContraRecibos';
import ReportesCobranza from './views/Cobranza/ReportesCobranza/ReportesCobranza';
import ContraRecibosReporte from './views/Ventas/Reportes/ContraRecibosReporte';
import ReporteManifiestos from './views/Ventas/Reportes/ReporteManifiestos';
import PagoTransportista from './views/Cobranza/ReportesCobranza/PagoTransportista/PagoTransportista.js.js';
import PagoTransportistaEntrega from './views/Cobranza/ReportesCobranza/PagoTransportista/PagoEntrega';
import ReportesContabilidad from './views/Ventas/Reportes/ReportesContabilidad';
import ManifiestosClis from './views/Catalogos/clientes/manifiestos/ManifiestosClis';
import PagosEntrega from './views/Ventas/PagoEntrega/PagosEntrega';
import Importar from './views/Cobranza/importaciones/Importar';
import PreguiaReporte from './views/Recolecciones/preguia/Reporte';
import Dashboard from './views/Dashboard/Dashboard';
import ConsultaSaldoFacturista from './views/Cobranza/ConsultaSaldoFacturista/ConsultaSaldoFacturista';
import Digitalizaciones from './views/Digitalizar/GuiasEntregadas/Digitalizaciones';
import Digitalizar from './views/Digitalizar/GuiasEntregadas/Digitalizar';
import ReporteScaner from './views/Digitalizar/Reporte/ReporteGuiasScaneadas';
import FacturasClientes from './views/Cobranza/FacturasCliente';
import FacturaCliente from './views/Cobranza/FacturasCliente/FacturaCliente';
import EnvioFacturas from './views/Cobranza/EnvioFacturas';
import EnvioFactura from './views/Cobranza/EnvioFacturas/EnvioFactura';
import TodayEAD from './views/EAD/TodayEADList';
import EADList from './views/EAD/EADList';
import EditEAD from './views/EAD/EditEAD';
import FacturasSatFaltantes from './views/Cobranza/FacturasSatFaltantes';
import ACCESS from './ACCESS';
import DetallePagoTransportista from './views/Cobranza/DetallePagoTransportista';
import RuleBuilder from './views/Cobranza/ReportesCobranza/PagoTransportista/RuleBuilder';
import TestEvaluador from './views/Cobranza/ReportesCobranza/PagoTransportista/TestEvaluador';
import IncidenciasManifiestos from './views/IncidenciasManifiestos/IncidenciasManifiestos';
let initialTT = null;

class AppAuth extends Component {

  constructor(props) {
    super(props);
    this.rutas = [
      { path: '/ConfiguracionSistema', Componente: ConfiguracionSistema, accion: 'show', access: [] }, // SOLO ADMIN
      { path: '/IncidenciasManifiestos', Componente: IncidenciasManifiestos, accion: 'show', access: [ACCESS.INCIDENCIAS_MANIFIESTOS.VER_INCIDENCIAS] },
      { path: '/Preguia/:id/Autorizar', Componente: Autorizar, accion: 'show', access: [ACCESS.PREGUIA.AUTORIZAR_PREGUIA] },
      {
        path: '/Preguias/Preguia/:id?', Componente: Preguia, accion: 'show', access: [ACCESS.PREGUIA.VER_PREGUIAS_CREADAS_POR_EL_USUARIO,
        ACCESS.PREGUIA.VER_PREGUIAS_SUCURSAL_DEL_USUARIO, ACCESS.PREGUIA.VER_TODAS_PREGUIAS]
      },
      {
        path: '/Preguias/Todas', Componente: Preguias, accion: 'show', access: [ACCESS.PREGUIA.VER_PREGUIAS_CREADAS_POR_EL_USUARIO,
        ACCESS.PREGUIA.VER_PREGUIAS_SUCURSAL_DEL_USUARIO, ACCESS.PREGUIA.VER_TODAS_PREGUIAS]
      },
      {
        path: '/Preguias/Reporte', Componente: PreguiaReporte, accion: 'show', access: [ACCESS.PREGUIA.REPORTE_ASIGNADAS_A_TRANSPORTISTA, ACCESS.PREGUIA.REPORTE_CONFIRMADAS_POR_TRANSPORTISTA,
        ACCESS.PREGUIA.REPORTE_DOCUMENTADAS, ACCESS.PREGUIA.REPORTE_EFECTUADAS_PENDIENTES_DE_DOCUMENTAR, ACCESS.PREGUIA.REPORTE_NO_CONFIRMADAS_POR_TRANSPORTISTA,
        ACCESS.PREGUIA.REPORTE_REALIZADAS_POR_TRANSPORTISTA, ACCESS.PREGUIA.REPORTE_TODAS_LAS_RECOLECCIONES]
      },
      { path: '/Catalogo', Componente: Catalogo, accion: 'show', access: [], sub_rute: true },
      { path: '/ListasDePrecios', Componente: ListaDePreciosIndex, accion: 'show', access: [ACCESS.LISTA_PRECIOS.VER_LISTA_PRECIOS] },
      { path: '/ListaPrecios', Componente: ListaPreciosForm, accion: 'show', access: [ACCESS.LISTA_PRECIOS.CREAR_LISTA_PRECIO] },
      { path: '/ListaPreciosEdit/:id', Componente: ListaPreciosForm, accion: 'edit', access: [ACCESS.LISTA_PRECIOS.VER_LISTA_PRECIOS] },
      /* { path: '/Recolecciones', Componente: Recolecciones, accion: 'show', access: [] }, */
      { path: '/Guias', Componente: Guias, accion: 'show', access: [], sub_rute: true },
      { path: '/RolesUsuario', Componente: RolesUsuario, accion: 'show', access: [] }, // SOLO ADMIN
      { path: '/RolUsuario', Componente: RolesUsuario, accion: 'show', access: [] }, // SOLO ADMIN
      { path: '/RolAccess/:id', Componente: RolAccess, accion: 'show', access: [] }, // SOLO ADMIN
      /* { path: '/RecibidasPorFacturacion', Componente: PendientesPorRecibir, accion: 'show', access: [] }, */
      {
        path: '/Ventas/Cotizaciones', Componente: Cotizaciones, accion: 'show', access: [ACCESS.VENTAS_COTIZACIONES.VER_COTIZACIONES_SUCURSAL_DEL_USUARIO, ACCESS.VENTAS_COTIZACIONES.VER_COTIZACIONES_SUCURSAL_DEL_USUARIO,
        ACCESS.VENTAS_COTIZACIONES.VER_TODAS_COTIZACIONES]
      },
      {
        path: '/Ventas/Cotizacion', Componente: Cotizacion, accion: 'show', access: [ACCESS.VENTAS_COTIZACIONES.VER_COTIZACIONES_SUCURSAL_DEL_USUARIO, ACCESS.VENTAS_COTIZACIONES.VER_COTIZACIONES_SUCURSAL_DEL_USUARIO,
        ACCESS.VENTAS_COTIZACIONES.VER_TODAS_COTIZACIONES]
      },
      { path: '/Ventas/Reportes/Corte', Componente: Corte, accion: 'show', access: [ACCESS.VENTAS_REPORTES.REPORTE_CORTE] },
      { path: '/Ventas/Reportes/Ventas', Componente: Ventas, accion: 'show', access: [ACCESS.VENTAS_REPORTES.REPORTE_VENTAS] },
      { path: '/Ventas/Reportes/CorteRedocumentacion', Componente: CorteRedocumentacion, accion: 'show', access: [ACCESS.VENTAS_REPORTES.REPORTE_ANEXO_CORTE_POR_REDOCUMENTACION] },
      { path: '/Ventas/Reportes/GuiasRedocumentadas', Componente: GuiasRedocumentasRep, accion: 'show', access: [ACCESS.VENTAS_REPORTES.REPORTE_GUIAS_REDOCUMENTADAS] },
      { path: '/Ventas/Reportes/VentasConcepto', Componente: VentasConcepto, accion: 'show', access: [ACCESS.VENTAS_REPORTES.REPORTE_VENTAS_POR_CONCEPTO] },
      { path: '/Ventas/Reportes/Contra-recibos', Componente: ContraRecibosReporte, accion: 'show', access: [ACCESS.VENTAS_REPORTES.REPORTE_CONTRA_RECIBOS] },
      { path: '/Ventas/Reportes/Completos', Componente: Completos, accion: 'show', access: [ACCESS.VENTAS_REPORTES.REPORTE_COMPLETOS] },
      { path: '/Ventas/Reportes/GuiasFactsPagos', Componente: GuiasFactsPagos, accion: 'show', access: [ACCESS.VENTAS_REPORTES.REPORTE_GUIAS_PAGOS] },
      { path: '/Ventas/Reportes/RecibidasFacturacion', Componente: RecibidasFact, accion: 'show', access: [ACCESS.VENTAS_REPORTES.REPORTE_GUIAS_RECIBIDAS_EN_FACTURACION] },
      { path: '/Ventas/Reportes/VentasCliente', Componente: VentasCliente, accion: 'show', access: [ACCESS.VENTAS_REPORTES.REPORTE_VENTAS_POR_CLIENTE] },
      { path: '/Ventas/Reportes/VentasEAD', Componente: VentasEAD, accion: 'show', access: [ACCESS.VENTAS_REPORTES.REPORTE_VENTAS_EAD] },
      { path: '/Ventas/Reportes/manifiestos', Componente: ReporteManifiestos, accion: 'show', access: [ACCESS.VENTAS_REPORTES.REPORTE_MANIFIESTOS] },
      { path: '/Ventas/Reportes/contabilidad', Componente: ReportesContabilidad, accion: 'show', access: [ACCESS.VENTAS_REPORTES.REPORTE_CONTABILIDAD] },
      { path: '/Ventas/Facturar', Componente: Facturar, accion: 'show', relatedPath: '/Ventas/Facturas', access: [ACCESS.VENTAS_FACTURAS_CONTADO.CREAR_FACTURA] },
      {
        path: '/Ventas/Facturas', Componente: Facturas, accion: 'show', access: [ACCESS.VENTAS_FACTURAS_CONTADO.VER_FACTURAS_CREADAS_POR_EL_USUARIO, ACCESS.VENTAS_FACTURAS_CONTADO.VER_FACTURAS_SUCURSAL_DEL_USUARIO,
        ACCESS.VENTAS_FACTURAS_CONTADO.VER_TODAS_FACTURAS]
      },
      {
        path: '/Ventas/FacturasCredito', Componente: FacturasCredito, accion: 'show', access: [ACCESS.VENTAS_FACTURAS_CREDITO.VER_FACTURAS_CREADAS_POR_EL_USUARIO, ACCESS.VENTAS_FACTURAS_CREDITO.VER_FACTURAS_SUCURSAL_DEL_USUARIO,
        ACCESS.VENTAS_FACTURAS_CREDITO.VER_TODAS_FACTURAS]
      },
      {
        path: '/Ventas/FacturarCredito/:id?', Componente: FacturarCreditoV2, accion: 'show', relatedPath: '/Ventas/FacturasCredito', access: [ACCESS.VENTAS_FACTURAS_CREDITO.VER_FACTURAS_CREADAS_POR_EL_USUARIO, ACCESS.VENTAS_FACTURAS_CREDITO.VER_FACTURAS_SUCURSAL_DEL_USUARIO,
          ACCESS.VENTAS_FACTURAS_CREDITO.VER_TODAS_LAS_FACTURAS]
      },
      {
        path: '/Ventas/FacturarCreditoV2/:id?', Componente: FacturarCreditoV2, accion: 'show', relatedPath: '/Ventas/FacturasCredito', access: [ACCESS.VENTAS_FACTURAS_CREDITO.VER_FACTURAS_CREADAS_POR_EL_USUARIO, ACCESS.VENTAS_FACTURAS_CREDITO.VER_FACTURAS_SUCURSAL_DEL_USUARIO,
        ACCESS.VENTAS_FACTURAS_CREDITO.VER_TODAS_FACTURAS]
      },
      {
        path: '/Ventas/FacturarCreditoV1/:id?', Componente: FacturarCredito, accion: 'show', relatedPath: '/Ventas/FacturasCredito', access: [ACCESS.VENTAS_FACTURAS_CREDITO.VER_FACTURAS_CREADAS_POR_EL_USUARIO, ACCESS.VENTAS_FACTURAS_CREDITO.VER_FACTURAS_SUCURSAL_DEL_USUARIO,
        ACCESS.VENTAS_FACTURAS_CREDITO.VER_TODAS_FACTURAS]
      },
      { path: '/Cobranza/Depositos', Componente: ControlPagos, accion: 'show', access: [ACCESS.COBRANZA_APLICACION_PAGOS.VER_CONTADO, ACCESS.COBRANZA_APLICACION_PAGOS.VER_CREDITO] },
      { path: '/Cobranza/DepositosDetalle/:id', Componente: Depositos, accion: 'show', access: [ACCESS.COBRANZA_APLICACION_PAGOS.VER_CONTADO, ACCESS.COBRANZA_APLICACION_PAGOS.VER_CREDITO] },
      { path: '/Cobranza/Deposito/:id', Componente: Deposito, accion: 'edit', access: [ACCESS.COBRANZA_CONTROL_DEPOSITO.IDENTIFICAR_DEPOSITO] },
      { path: '/Cobranza/ApliacionPago/Busqueda/:type', Componente: AppBusqueda, accion: 'show', relatedPath: '/Cobranza/ApliacionPago/Busqueda', access: [ACCESS.COBRANZA_APLICACION_PAGOS.VER_CONTADO, ACCESS.COBRANZA_APLICACION_PAGOS.VER_CREDITO] },
      { path: '/Cobranza/ApliacionPago/Depositos', Componente: AppDepositos, accion: 'edit', access: [ACCESS.COBRANZA_APLICACION_PAGOS.VER_CONTADO, ACCESS.COBRANZA_APLICACION_PAGOS.VER_CREDITO] },
      { path: '/Cobranza/ApliacionPago/Deposito/:id', Componente: AppDeposito, accion: 'show', access: [ACCESS.COBRANZA_APLICACION_PAGOS.VER_CONTADO, ACCESS.COBRANZA_APLICACION_PAGOS.VER_CREDITO] },
      {
        path: '/Cobranza/descargar-archivos', Componente: DescargarArchivos, accion: 'show', access: [ACCESS.COBRANZA_DESCARGA_DE_ARCHIVOS.DESCARGAR_FACTURA_CONTADO, ACCESS.COBRANZA_DESCARGA_DE_ARCHIVOS.DESCARGAR_FACTURA_CREDITO,
        ACCESS.COBRANZA_DESCARGA_DE_ARCHIVOS.DESCARGAR_NOTA_CREDITO]
      },
      { path: '/Cobranza/poliza-contable', Componente: PolizaContable, accion: 'show', access: [ACCESS.COBRANZA_POLIZA_CONTABLE.DESCARGAR] },
      { path: '/Cobranza/notas-credito', Componente: NotasCredito, accion: 'show', access: [ACCESS.COBRANZA_NOTA_CREDITO.VER_TODAS_NOTAS_CREDITO, ACCESS.COBRANZA_NOTA_CREDITO.VER_NOTAS_CREADAS_POR_EL_USUARIO] },
      { path: '/Cobranza/nota-credito/:id?', Componente: NotaCredito, accion: 'show', access: [ACCESS.COBRANZA_NOTA_CREDITO.VER_TODAS_NOTAS_CREDITO, ACCESS.COBRANZA_NOTA_CREDITO.VER_NOTAS_CREADAS_POR_EL_USUARIO] },
      { path: '/Cobranza/contra-recibos', Componente: ContraRecibos, accion: 'show', access: [ACCESS.COBRANZA_CONTRA_RECIBO.VER_TODOS_LOS_CONTRARECIBOS] },
      {
        path: '/Cobranza/reportes', Componente: ReportesCobranza, accion: 'show', access: [ACCESS.COBRANZA_REPORTES.REPORTE_ESTADO_DE_CUENTA, ACCESS.COBRANZA_REPORTES.REPORTE_MOVIMIENTOS_CLIENTE,
        ACCESS.COBRANZA_REPORTES.REPORTE_COBRANZA_DETALLADA, ACCESS.COBRANZA_REPORTES.REPORTE_COBRANZA_GLOBAL]
      },
      { path: '/Cobranza/reporte-pagos', Componente: DiferenciaPagosRealizados, accion: 'show', access: [ACCESS.COBRANZA_REPORTES.REPORTE_DE_PAGOS_CREDITO] },
      { path: '/Cobranza/reporte-pagos-contado', Componente: ReportePagoContado, accion: 'show', access: [ACCESS.COBRANZA_REPORTES.REPORTE_DE_PAGOS_CONTADO] },
      { path: '/Cobranza/reporte-pagos-pendientes', Componente: PagosPendientesTimbrar, accion: 'show', access: [ACCESS.COBRANZA_REPORTES.REPORTE_DE_PAGOS_PENDIENTES] },
      { path: '/Cobranza/reporte-diferencia-pagos', Componente: DiferenciaDePagos, accion: 'show', access: [ACCESS.COBRANZA_REPORTES.REPORTE_DIFERENCIA_DE_PAGOS] },
      { path: '/Cobranza/reporte-relacion-fact', Componente: RelacionFacturas, accion: 'show', access: [ACCESS.COBRANZA_REPORTES.REPORTE_RELACION_FACTURAS] },
      { path: '/Cobranza/pagos/pago-transportista', Componente: PagoTransportista, accion: 'show', access: [ACCESS.COBRANZA_PAGO_TRANSPORTISTA.PAGO_RECOLECCION] },
      { path: '/Cobranza/pagos/pago-entrega', Componente: PagosEntrega, accion: 'show', access: [ACCESS.COBRANZA_PAGO_TRANSPORTISTA.PAGO_ENTREGA] },
      { path: '/Cobranza/pagos/pago-transportista-entrega', Componente: PagoTransportistaEntrega, accion: 'show', access: [ACCESS.COBRANZA_PAGO_TRANSPORTISTA.PAGO_ENTREGA] },
      { path: '/Cobranza/pagos/detalle-pago-transportista', Componente: DetallePagoTransportista, accion: 'show', access: [ACCESS.COBRANZA_PAGO_TRANSPORTISTA.VER_DETALLE_PAGO_TRANSPORTISTA] },
      { path: '/Cobranza/pagos/reglas-pago-transportista', Componente: RuleBuilder, accion: 'show', access: [ACCESS.COBRANZA_PAGO_TRANSPORTISTA.MODIFICAR_PAGO_TRANSPORTISTA] },
      { path: '/Cobranza/pagos/test-evaluador', Componente: TestEvaluador, accion: 'show', access: [ACCESS.COBRANZA_PAGO_TRANSPORTISTA.MODIFICAR_PAGO_TRANSPORTISTA] },
      { path: '/Cobranza/RecibirGuia/:id', Componente: RecibidasPorFacturacion, accion: 'show', access: [ACCESS.COBRANZA_GUIAS_RECIBIDAS.REVISAR_FOLIO] },
      { path: '/Cobranza/ConsultaSaldoFacturista', Componente: ConsultaSaldoFacturista, accion: 'show', access: [ACCESS.COBRANZA_SALDO_FACTURISTA] },
      { path: '/Manifiestos/:id?', Componente: ManifiestosClis, accion: 'show', access: [ACCESS.ARCHIVOS_DE_CLIENTE.SUBIR_ARCHIVO] },
      { path: '/Cobranza/GuiasPendientes', Componente: PendientesFacturar, accion: 'show', access: [ACCESS.COBRANZA_GUIAS_PENDIENTES.DESCARGAR_REPORTE] },
      { path: '/Cobranza/FacturasConsecutivo', Componente: ConsecutivoFacturas, accion: 'show', access: [ACCESS.COBRANZA_CONSECUTIVO_DE_FACTURAS.DESCARGAR_REPORTE] },
      { path: '/Cobranza/FacturasEnviadas', Componente: FacturasEnviadas, accion: 'show', access: [ACCESS.COBRANZA_GUIAS_RECIBIDAS.VER_TODAS_LOS_FOLIOS, ACCESS.COBRANZA_GUIAS_RECIBIDAS.VER_FOLIOS_SUCURSAL_DEL_USUARIO] },
      /* { path: '/importar', Componente: Importar, accion: 'show', access: [] }, */
      { path: '/Ventas/Calcularkm', Componente: CalcularKM, accion: 'show', access: [ACCESS.VENTAS_CALCULAR_KM.CALCULAR_KM] },
      { path: '/Ventas/FacturaUline', Componente: FacturarUline, accion: 'show', access: [ACCESS.VENTAS_FACTURA_ULINE.CREAR_FACTURA_ULINE] },
      { path: '/Ventas/CancelacionesFacturas', Componente: CancelacionesIndex, accion: 'show', access: [ACCESS.VENTAS_MULTIPLE_CANCELACION.VER_CANCELACIONES] },
      { path: '/Ventas/CancelacionFactura', Componente: MultipleCancelaciones, accion: 'show', access: [ACCESS.VENTAS_MULTIPLE_CANCELACION.VER_CANCELACIONES] },
      { path: '/Cobranza/reporte-rutas', Componente: RelacionRutas, accion: 'show', access: [ACCESS.COBRANZA_REPORTES.REPORTE_PARA_RUTAS] },
      { path: '/Digitalizar/GuiasEntregadas', Componente: Digitalizaciones, accion: 'show', access: [ACCESS.DIGITALIZAR.VER_DIGITALIZACIONES] },
      { path: '/Digitalizar/GuiaEntregada/:id?', Componente: Digitalizar, accion: 'show', access: [ACCESS.DIGITALIZAR.VER_DIGITALIZACIONES] },
      { path: '/Digitalizar/Reporte', Componente: ReporteScaner, accion: 'show', access: [ACCESS.DIGITALIZAR.DESCARGAR_EVIDENCIA] },
      { path: '/Cobranza/FacturasClientes', Componente: FacturasClientes, accion: 'show', access: [ACCESS.COBRANZA_FACTURAS_POR_CLIENTE.VER_TODOS_LOS_FOLIOS, ACCESS.COBRANZA_FACTURAS_POR_CLIENTE.VER_FOLIOS_CREADOS_POR_USUARIO] },
      { path: '/Cobranza/FacturaCliente/:id?', Componente: FacturaCliente, accion: 'show', access: [ACCESS.COBRANZA_FACTURAS_POR_CLIENTE.VER_TODOS_LOS_FOLIOS, ACCESS.COBRANZA_FACTURAS_POR_CLIENTE.VER_FOLIOS_CREADOS_POR_USUARIO] },
      {
        path: '/Ventas/Refacturaciones', Componente: Refacturaciones, accion: 'show', access: [ACCESS.VENTAS_REFACTURACION.VER_TODAS_FACTURAS, ACCESS.VENTAS_REFACTURACION.VER_FACTURAS_CREADAS_POR_EL_USUARIO,
        ACCESS.VENTAS_REFACTURACION.VER_FACTURAS_SUCURSAL_DEL_USUARIO]
      },
      {
        path: '/Ventas/Refacturar/:id?', Componente: Refacturar, accion: 'show', access: [ACCESS.VENTAS_REFACTURACION.VER_TODAS_FACTURAS, ACCESS.VENTAS_REFACTURACION.VER_FACTURAS_CREADAS_POR_EL_USUARIO,
        ACCESS.VENTAS_REFACTURACION.VER_FACTURAS_SUCURSAL_DEL_USUARIO]
      },
      {
        path: '/Cobranza/envio-facturas', Componente: EnvioFacturas, accion: 'show', access: [ACCESS.COBRANZA_ENVIO_FACTURAS.VER_FOLIOS_CREADOS_POR_USUARIO,
        ACCESS.COBRANZA_ENVIO_FACTURAS.VER_FOLIOS_SUCURSAL_USUARIO, ACCESS.COBRANZA_ENVIO_FACTURAS.VER_TODOS_LOS_FOLIOS]
      },
      {
        path: '/Cobranza/envio-factura/:id?', Componente: EnvioFactura, accion: 'show', access: [ACCESS.COBRANZA_ENVIO_FACTURAS.VER_FOLIOS_CREADOS_POR_USUARIO,
        ACCESS.COBRANZA_ENVIO_FACTURAS.VER_FOLIOS_SUCURSAL_USUARIO, ACCESS.COBRANZA_ENVIO_FACTURAS.VER_TODOS_LOS_FOLIOS]
      },
      { path: '/EAD/CitasDia', Componente: TodayEAD, accion: 'show', access: [ACCESS.CITAS_EAD.VER_TODAS_SUCURSAL, ACCESS.CITAS_EAD.VER_TODAS_CLIENTE, ACCESS.CITAS_EAD.VER_TODAS, ACCESS.CITAS_EAD.VER_TODAS_USUARIO] },
      { path: '/EAD/Citas', Componente: EADList, accion: 'show', access: [ACCESS.CITAS_EAD.VER_TODAS_SUCURSAL, ACCESS.CITAS_EAD.VER_TODAS_CLIENTE, ACCESS.CITAS_EAD.VER_TODAS, ACCESS.CITAS_EAD.VER_TODAS_USUARIO] },
      { path: '/EAD/Edit/:id?', Componente: EditEAD, accion: 'show', access: [ACCESS.CITAS_EAD.VER_TODAS_SUCURSAL, ACCESS.CITAS_EAD.VER_TODAS_CLIENTE, ACCESS.CITAS_EAD.VER_TODAS, ACCESS.CITAS_EAD.VER_TODAS_USUARIO] },
      { path: '/Cobranza/FacturasSatFaltantes', Componente: FacturasSatFaltantes, accion: 'show', access: [ACCESS.COBRANZA_REPORTES.REPORTE_FACTURAS_SAT_FALTANTES] },
      { path: '/', Componente: Dashboard, accion: 'show', access: [] },
    ];
    this.state = {
      showSearchNavigator: false,
      recursos: []
    };
  }

  componentDidMount() {
    let {
      hasAccess
    } = this.context;
    window.onkeydown = this.keyPress;
    let validResources = this.rutas.filter(r => hasAccess(r.access) || r.sub_rute);

    this.setState({
      recursos: validResources
    });
    initialTT = localStorage.getItem('tt');

    window.addEventListener('storage', () => {
      let currentTT = localStorage.getItem('tt');
      // console.log('CAMBIO LOCAL STORAGHE', initialTT, currentTT);
      if (!currentTT || initialTT !== currentTT) window.location.reload();
    });
  }

  keyPress = (e) => {
    if (e.keyCode === 90 && e.ctrlKey) {
      this.setState({ showSearchNavigator: !this.state.showSearchNavigator });
    }
  }

  logOut = async () => {
    try {
      localStorage.removeItem('tt');
      this.props.onLogOut();
      this.props.history.push('/')
    } catch (error) {
      console.log(error)
    }
  }

  render() {
    const {
      user: {
        nombre,
        apellido_paterno,
        sucursal
      },
    } = this.context;
    return (
      <React.Fragment>
        <div className="bs">
          <Button
            color='primary'
            onClick={() => this.props.history.goBack()}
            startIcon={<Icon>arrow_back_outlined</Icon>}
          >
            Regresar
          </Button>
          <div className="userinfo" >
            <span className="info" >
              {`${nombre} ${apellido_paterno} - ${sucursal}`}
            </span>
          </div>
          <div>
            <a href='https://exxprezo-helpdesk.freshdesk.com/support/login' target="_blank" >
              <Icon color="secondary" fontSize="large" style={{ cursor: 'pointer', margin: 5 }} >contact_support</Icon>
            </a>
            <Link to='/ConfiguracionSistema' >
              <Icon color="secondary" fontSize="large" style={{ cursor: 'pointer', margin: 5 }} >settings_applications</Icon>
            </Link>
            <Icon color="secondary" fontSize="large" style={{ cursor: 'pointer', margin: 5 }} onClick={this.logOut}>exit_to_app</Icon>
          </div>
        </div>
        <div style={{ display: 'flex', flexFlow: 'row' }} >
          <Side />
          <div className="body-container">
            <Switch>
              {
                this.state.recursos.map((recurso, index) => (
                  <Route key={`ruta-${index}`} path={recurso.path}>
                    <recurso.Componente />
                  </Route>)
                )
              }
              {/* <Route path="/Guias/Documentadas">
                <Documentadas></Documentadas>
              </Route>
              <Route path="/Guias">
                <Guias></Guias>
              </Route> */}
            </Switch>
          </div>
        </div>
        {
          this.state.showSearchNavigator && (
            <SearchNavigator {...this.props} onSelect={() => { this.setState({ showSearchNavigator: false }) }} />)
        }
      </React.Fragment>
    )
  }
}
AppAuth.contextType = AuthContext;
export default withRouter(AppAuth)